import { components, ClearIndicatorProps } from 'react-select';
import { SelectStyleProps } from './types';

export const DropdownIndicator = ({
  showCount,
  current,
  limit,
  showDropdownIndicator,
  indicateHasReachedLimit,
}: {
  current: number;
  limit?: number;
  showCount: boolean;
} & Pick<SelectStyleProps, 'indicateHasReachedLimit' | 'showDropdownIndicator'>) => {
  if (!showDropdownIndicator) {
    return <HiddenDropdownIndicator />;
  }

  const icon = <i className='fa-light fa-caret-down mx-2' />;
  if (!showCount || !limit) {
    return icon;
  }

  const color = indicateHasReachedLimit && current === limit ? 'text-ThemeWarningDark' : '';

  return (
    <div className='d-flex align-items-center'>
      <span className={`text-sm ml-1 ${color}`}>({current + '/' + limit})</span>
      {icon}
    </div>
  );
};

export const HiddenDropdownIndicator = () => <span className='mx-1'></span>;

export const ClearIndicator = <T = string | null,>(props: ClearIndicatorProps<T>) => {
  return (
    <components.ClearIndicator {...props}>
      <i className='fal fa-xmark p-0 ml-3 text-md' />
    </components.ClearIndicator>
  );
};
